// extracted by mini-css-extract-plugin
export default {"freeze-content":"Freeze_freeze-content__LJJRL","freeze-select":"Freeze_freeze-select__uB9eh"};